import ReaderConfigurations from 'collections/newsroom/configurations';

export default new ReaderConfigurations();
